import dayjs, { Dayjs } from "dayjs";
import { ISODateParseFormat } from "src/constants";

export const DateStringYYYYMMDDToMoment = (date = ""): Dayjs => {
  return dayjs(date, ISODateParseFormat);
};

export default DateStringYYYYMMDDToMoment;
